<div class="body-main">
	<div class="body-main-top">

		<div class="">
			<form class="" #ruleengineManageform="ngForm" novalidate>
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-12">
							<div class="project-heading">
								<div class="rule-head">

									<h1>{{AccProjectdet.accountName}} - {{AccProjectdet.projectName}}</h1>
									<button type="button" class="btn btn-secondary fl-right"
										(click)="backtoSection('application')"><i class="fa fa-long-arrow-left"></i>
										Back
										to Application</button>
								</div>


								<ul class="rule-list-btn">



									<!-- <div class="col-sm-2">
							<a class="btn btn-primary " (click)="backtoSection('ageconfig')"><i
									class="glyphicon glyphicon-plus"></i>Age Config</a>
						</div> -->


									<li>
										<a class="btn btn-primary " (click)='resetRuleEng();'><i
												class="glyphicon glyphicon-plus"></i>Add Rule</a>
									</li>
									<li>
										<a class="btn btn-primary " (click)='resetAgeEng();'><i
												class="glyphicon glyphicon-plus"></i> Age</a>
									</li>
									<li>
										<a class="btn btn-primary " (click)='resetWorkexpEng();'><i
												class="glyphicon glyphicon-plus"></i> Work Exp</a>
									</li>
									<li>
										<a class="btn btn-primary " (click)='resetDependentFld();'><i
												class="glyphicon glyphicon-plus"></i> Dependent Field</a>
									</li>
									<li>
										<a class="btn btn-primary " (click)='resetPreferenceFld();'><i
												class="glyphicon glyphicon-plus"></i> Preference</a>
									</li>
									<li>
										<a class="btn btn-primary " (click)='resetDataGridEng();'><i
												class="glyphicon glyphicon-plus"></i>Grid Validations</a>
									</li>

								</ul>
							</div>

						</div>

					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="rule-box" *ngIf='showCRRule' id="CRContainer">
								<h1 class="rule-main-head">Create Rule</h1>

								<div class="row">
									<div class="col-md-12">
										<div class="row">
											<div class="col-md-6">
												<h2 class="rule-sub-head">Rule</h2>
												<query-builder [(ngModel)]='query' [config]='config' name="query"
													class="query-style"></query-builder>
											</div>
											<div class="col-md-6">
												<form class="" (ngSubmit)="convertJsonQuery(ruleengineform)"
													#ruleengineform="ngForm" novalidate>
													<div class="alert alert-danger"
														*ngIf="ruledesM.errors?.required && ruleengineform.submitted">
														Rule is required.
													</div>
													<h2 class="rule-sub-head">Rules to append</h2>
													<div class="form-group">
														<label>Rule For:</label>
														<select [(ngModel)]='ruleFor' required name='ruleFor'
															id="ruleFor" #ruleForM="ngModel" [disabled]='showEditRule'>
															<option value=''>--Select--</option>
															<option *ngFor="let rule of ruleForVal"
																value="{{rule.ruleValue}}">{{rule.ruleDisplay}}
															</option>
														</select>
														<div class="alert alert-danger"
															*ngIf="ruleForM.errors?.required && ruleengineform.submitted">
															Field Name is required.
														</div>
													</div>
													<div *ngIf="(ruleFor == 'Fee')?true:false">
														<div class="form-group"
															*ngFor="let key of query.rules; let i = index;">
															<label>Fee {{i+1}} </label>
															<select [(ngModel)]="feeCond['feeCond' + (+i + 1)]" required
																name='feeCond{{i+1}}' id="feeCond{{i+1}}">
																<option value="{{i+1}}">Condition{{i+1}}</option>
															</select>
															<input type="text" name="feeVal{{i+1}}" id="feeVal{{i+1}}"
																[(ngModel)]="feeCond['feeVal' + (+i + 1)]" />
															<!--div class="alert alert-danger" *ngIf="feeCondM.errors?.required && ruleengineform.submitted">
											  Field Name is required.
										  </div-->
														</div>
													</div>
													<div class="form-group">
														<label>Field Name:</label>
														<select [(ngModel)]='inputSelectInsert' required
															name='inputSelectInsert' id="inputSelectInsert"
															#inputSelectInsertM="ngModel" [disabled]='showEditRule'>
															<option value=''>--Select--</option>
															<option *ngFor="let inputVal of inputFiledSel"
																value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
																{{inputVal.DisplayVal}} -
																{{inputVal.keyVal}}</option>
														</select>
														<div class="alert alert-danger"
															*ngIf="inputSelectInsertM.errors?.required && ruleengineform.submitted">
															Field Name is required.
														</div>
													</div>
													<div class="form-group"
														*ngIf="(ruleFor != 'Conditional')?true:false">
														<label>Alert Message to Display:</label>
														<textarea rows="2" cols="100" name="alertmsgstr"
															[(ngModel)]="alertmsgstr" #alertmsgstrM="ngModel"
															required></textarea>
														<div class="alert alert-danger"
															*ngIf="alertmsgstrM.errors?.required && ruleengineform.submitted">
															Alert Message is required.
														</div>
													</div>

													<textarea rows="10" cols="50" style="display:none;"
														name="convertedStr" [(ngModel)]="query.rules"
														#ruledesM="ngModel" required></textarea>

													<div class="form-group">
														<button class="btn btn-primary pull-right" type="submit"
															[disabled]="!btnSubmission"
															name="generate_btn">Generate</button>
													</div>



													<!-- <textarea rows="10" cols="50"  >{{jsonConvertedString}}</textarea>
									  <hr>
				
									   <h1>Input details</h1>
										<textarea rows="15" cols="150"  >{{QueryBuilderConfigOrigArr | json}}</textarea>
				
										<h1>Input details</h1>
										<textarea rows="15" cols="150"  >{{query | json}}</textarea>
				
										 <h1>Input details</h1>
										<textarea rows="15" cols="150"  >{{config | json}}</textarea> -->
												</form>



											</div>

										</div>
									</div>
								</div>
							</div>
							<div *ngIf='showRuleng' id="fffff">
								<div class="rule-box">
									<h1 class="rule-main-head">Rule Engine</h1>
									<div class="col-md-8  py-1">


										<!--<div *ngIf="rtnStatusData && rtnStatusData.success == true" class="alert alert-success">
							  {{ rtnStatusData.message }}
						  </div>-->
										<div class="">
											<div class="col-sm-5 p-0 mb-4 pull-right">
												<div class="input-group rule-search-input">
													<input type="text" [(ngModel)]='inputSearch' name='inputSearch'
														#inputSearchM="ngModel" placeholder="Search Field Name here">
													<div class="rule-search-input-btn">
														<button
															class="btn btn-outline-secondary border-left-0 rounded-0 rounded-right"
															(click)='searchStatus();'>
															<i class="fa fa-search"></i>
														</button>
													</div>
												</div>
											</div>
										</div>
										<div class="table-responsive">
											<table class="table table-fixed table-striped table-bordered table-hover">
												<thead>
													<tr>
														<th class="col-md-5">Field Name</th>
														<th class="col-md-3">Created date</th>
														<th class="col-md-2">Rule For</th>
														<th class="col-md-2">Action</th>
														<!-- <th>Status</th> -->
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let ruleData of ruleEngineData; let i = index">
														<td class="col-md-5">{{ruleData.appendFieldLabel}}</td>
														<td class="col-md-3">{{ruleData.createdDate | date : 'dd-MM-yyyy
															hh:mm:ss'}}</td>
														<td class="col-md-2">
															<span *ngFor="let rule of ruleForVal"><span
																	*ngIf="rule.ruleValue == ruleData.ruleFor">{{rule.ruleDisplay}}</span></span>
														</td>
														<td class="col-md-2">
															<i class="fa d-inline fa-lg fa-eye view-icon"
																(mouseenter)="jsonpreviewView(ruleData.rulesJsonLogic,'show')"></i>
															<i class="fa d-inline fa-lg fa-edit "
																(click)='EditRuleField(ruleData.ruleid);'
																href="#CRContainer"></i>
															<i class="fa d-inline fa-lg fa-trash-o del"
																(click)='DelRuleField(ruleData.appendField,ruleData.ruleid,ruleData.ruleFor);'></i>
														</td>
														<!-- <td><span [ngClass]="ruleData.rule_status == 'Active' ? 'label label-success' : 'label label-warning'"> {{ruleData.rule_status}}</span></td>  -->
														<div class="clearfix"></div>
													</tr>
													<tr *ngIf="ruleEngineData.length == 0">
														<td colspan='3'>No Rule(s) found.</td>
													</tr>
												</tbody>
											</table>
										</div>
										<!--
							<div class="row py-0">
							  <div class=" col-xs-10 offset-xs-2  col-sm-10 offset-sm-2  col-md-10 offset-md-2">
								<ul class="pagination">
								  <li class="page-item">
									<a class="page-link" href="#" aria-label="Previous"> <span aria-hidden="true">«</span> <span class="sr-only">Previous</span> </a>
								  </li>
								  <li class="page-item">
									<a class="page-link" href="#">1</a>
								  </li>
								  <li class="page-item">
									<a class="page-link" href="#">2</a>
								  </li>
								  <li class="page-item">
									<a class="page-link" href="#">3</a>
								  </li>
								  <li class="page-item">
									<a class="page-link" href="#">4</a>
								  </li>
								  <li class="page-item">
									<a class="page-link" href="#" aria-label="Next"> <span aria-hidden="true">»</span> <span class="sr-only">Next</span> </a>
								  </li>
								</ul>
							  </div>
							</div>
							-->
									</div>
									<div class="col-md-4 py-1">
										<div *ngIf='displayPrevJson'>
											<h2 class="rule-sub-head">Preview</h2>

											<div style="background: #fff;">
												<pre>{{displayPrevJsonVal | json}}</pre>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="col-md-12">
			<div class="rule-box" *ngIf='showWorkexpRule' id="WorkexpContainer">
				<h1 class="rule-main-head"> Work Experience</h1>

				<!--firstsection-->
				<!-- <form class="" (ngSubmit)="onSubmit()" [formGroup]="myFormworkexp"  novalidate>

						  <div formArrayName="workexp" >
							  <div *ngFor="let language of myFormworkexp.controls.workexp.controls; let ix=index" >
									  <div class="row">
										<div class="form-group">
										  <div formGroupName="{{ix}}">
												  <div class="col-md-3">
													  <label for="appStartDate">From Date</label>

													<select  required name='fromdate' id="fromdate"  formControlName="fromdate" style="width:250px;">
													  <option value=''>--Select--</option>
													  <option *ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]" value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
													</select>
												  </div>

												  <div class="col-md-3">
													<label for="appStartDate">To Date</label>
													<select  required name='todate' id="todate"  formControlName="todate" style="width:250px;">
													  <option value=''>--Select--</option>
													  <option *ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]" value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
													</select>
												  </div>

											  <div class="col-md-3">
												  <label >Field Name:</label>
												   <select required name='CalcAppendField' formControlName="CalcAppendField" id="CalcAppendField" style="width:250px;">
													  <option value=''>--Select--</option>
													  <option *ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]" value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
													</select>
											   </div>

											  <div class="col-md-3">
												  <label >&nbsp;<br/></label>
												  <span style="padding-top:30px;" class="glyphicon glyphicon-remove " *ngIf="myFormworkexp.controls.workexp.controls.length > 1" (click)="removeSection_workexp(ix)"></span>
											  </div>
										  </div>
									  </div>
									</div>
							 </div>
						  </div>

						   <div class="row" >
							  <div class="form-group col-md-10">
							   <a class="btn btn-primary pull-right" (click)='AddWorkexpcol("");'><i title="Add Work Experience" class="glyphicon glyphicon-plus"></i></a>
							  </div>
						   </div>

						   <div class="row">&nbsp;</div>

						   <div class="row">
							  <div class="form-group col-md-10">
								  <label for="totexp">Total Work Experience in Months Field Name</label>
								  <select  required name='totexp' id="totexp"  formControlName="totexp" style="width:250px;">
									  <option value=''>--Select--</option>
									  <option *ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]" value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
								  </select>
							  </div>
						   </div>

						   <div class="row">
							   <div class="form-group col-md-10">
								   <button class="btn btn-primary pull-right" type="submit"  name="generate_btn">Save</button>
							   </div>
						   </div>
			  </form> -->


				<!--work experience section armed forces-->
				<form class="" (ngSubmit)="armedForcesSubmit()" [formGroup]="myFormworkexpArmedForces" novalidate>
					<h2 class="rule-sub-head">Work Experience in</h2>
					<div formArrayName="workexpArmedContainer">

						<div
							*ngFor="let language of myFormworkexpArmedForces.controls.workexpArmedContainer.controls; let ix=index">
							<div class="row">
								<div class="col-md-12 form-group">

									<div class="row" formGroupName="{{ix}}">


										<div class="col-md-4">
											<label for="appStartDateArmed">From Date</label>

											<select required name='fromdatearmed' id="fromdatearmed"
												formControlName="fromdatearmed" style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>

										<div class="col-md-4">
											<label for="appStartDateArmed">To Date</label>
											<select required name='todatearmed' id="todatearmed"
												formControlName="todatearmed" style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>

										<div class="col-md-4">
											<label>Field Name:</label>


											<select required name='CalcAppendFieldarmed'
												formControlName="CalcAppendFieldarmed" id="CalcAppendFieldarmed"
												style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>


									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="form-group col-md-12">
							<label for="totexp">Total Work Experience in Months Field Name</label>
							<select required name='totexparmed' id="totexparmed" formControlName="totexparmed"
								style="width:250px;">
								<option value=''>--Select--</option>
								<option
									*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]"
									value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">{{inputVal.DisplayVal}} -
									{{inputVal.keyVal}}</option>
							</select>
						</div>
					</div>

					<div class="row">
						<div class="form-group col-md-12">
							<button class="btn btn-primary pull-right" type="submit"
								name="generate_btn_armed">Save</button>
						</div>
					</div>
				</form>

				<!--end of work exp armed forces-->
				<h2 class="rule-sub-head">Post Based Work Experience</h2>
				<form style="position: relative;" (ngSubmit)="onSubmit()" [formGroup]="myFormworkexp" novalidate>

					<div formArrayName="workexp">
						<div class="age-config-row" *ngFor="let language of myFormworkexp.controls.workexp.controls; let ix=index">
							<div class="row">
								<div class="col-md-12 form-group">
									<div class="" formGroupName="{{ix}}">
										<div class="age col-md-12">
										<div class="col-md-4">
											<label for="appStartDate">From Date</label>

											<select required name='fromdate' id="fromdate" formControlName="fromdate"
												style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>

										<div class="col-md-4">
											<label for="appStartDate">To Date</label>
											<select required name='todate' id="todate" formControlName="todate"
												style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>

										<div class="col-md-4">
											<label>Field Name:</label>


											<select required name='CalcAppendField' formControlName="CalcAppendField"
												id="CalcAppendField" style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>

										<div class="age-confic-action-icon">
										
											<span title="Remove Experience" class="glyphicon glyphicon-remove del"
												*ngIf="myFormworkexp.controls.workexp.controls.length > 1"
												(click)="removeSection_workexp(ix)"></span>
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>
					</div>


						<div class="form-group age-confic-add-btn">
							<a class="btn btn-primary add-button pull-right" (click)='AddWorkexpcol("");'><i
									title="Add Work Experience" class="glyphicon glyphicon-plus"></i></a>
						</div>
					

					<div class="row">&nbsp;</div>



					<div class="row">

						<!--Field exp years-->
						<!-- <div class="col-md-3">
						  <label>Field Name:</label>


						  <select required name='CalcAppendField' formControlName="CalcAppendField" id="CalcAppendField"
							  style="width:250px;">
							  <option value=''>--Select--</option>
							  <option
								  *ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]"
								  value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
								  {{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
						  </select>
					  </div> -->

						<div class="form-group col-md-12">
							<label for="totexp">Total Work Experience in Months Field Name</label>
							<select required name='totexp' id="totexp" formControlName="totexp" style="width:250px;">
								<option value=''>--Select--</option>
								<option
									*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]"
									value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
									{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
							</select>
						</div>
					</div>

					<div class="row">
						<div class="form-group col-md-12">
							<button class="btn btn-primary pull-right" type="submit" name="generate_btn">Save</button>
						</div>
					</div>
				</form>

				<h2 class="rule-sub-head">Dynamic Row Method</h2>
				<form class="" (ngSubmit)="DynWorkExpSubmit()" [formGroup]="myDynFormworkexp" novalidate>
					<div formArrayName="dynworkexp">
						<div *ngFor="let language of myDynFormworkexp.controls.dynworkexp.controls; let ix=index">
							<div class="row">
								<div class="col-md-12 form-group">
									<div class="row" formGroupName="{{ix}}">
										<div class="col-md-4">
											<label for="dynappStartDate">From Date</label>

											<select required formControlName="dynfromdate" name='dynfromdate'
												id="dynfromdate" style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>

										<div class="col-md-4">
											<label for="dynappStartDate">To Date</label>
											<select required formControlName="dyntodate" name='dyntodate' id="dyntodate"
												style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'datetime'},{'typeVal' : 'day'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>

										<div class="col-md-4">
											<label>Field Name:</label>
											<select required formControlName="dynCalcAppendField"
												name='dynCalcAppendField' id="dynCalcAppendField" style="width:250px;">
												<option value=''>--Select--</option>
												<option
													*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]"
													value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
													{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="form-group col-md-12">
							<label for="totexp">Total Work Experience in Months Field Name</label>
							<select required name='dyntotexp' id="dyntotexp" formControlName="dyntotexp"
								style="width:250px;">
								<option value=''>--Select--</option>
								<option
									*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal' : 'number'}]"
									value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">{{inputVal.DisplayVal}} -
									{{inputVal.keyVal}}</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-md-12">
							<button class="btn btn-primary pull-right" type="submit"
								name="dyngenerate_btn">Save</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="col-md-12">
			<div class="rule-box" *ngIf='showAge' id="AgeContainer">
				<h1 class="rule-main-head">Age Config</h1>

				<div class="row">
					<div class="col-md-12 py-1">
						<form class="" (ngSubmit)="convertJsonQuery1()" [formGroup]="myForm" novalidate>
							<!--(ngSubmit)="convertJsonQuery()" -->
							<!-- (ngSubmit)="convertJsonQuery(ageform)" #ageform="ngForm"  -->
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label>Age Dependent:</label>
										<select required name='ageDep' id="ageDep" formControlName="ageDep">
											<option value=''>--Select--</option>
											<option value="Y">Yes</option>
											<option value="N">No</option>
										</select>
										<!--div class="alert alert-danger" *ngIf="ageDepM.errors?.required && ageform.submitted">Age Dependent is required.</div-->
									</div>
									<div *ngIf="(ageDep.value == 'Y')?true:false">
										<div formArrayName="dependenton">
											<div
												*ngFor="let depfield of myForm.controls.dependenton.controls; let ix=index">
												<div class="form-group">
													<div formGroupName="{{ix}}">
														<label>Dependent On:</label>
														<select required name='formFields' id="formFields"
															formControlName="formFields" (change)="ageConfigMap()">
															<option value=''>--Select--</option>
															<option *ngFor="let inputVal of inputFiledSel"
																value="{{inputVal.keyVal}}">{{inputVal.DisplayVal}}
																- {{inputVal.keyVal}}</option>
														</select>


														<label>&nbsp;<br /></label>
														<span style="padding-top:30px;"
															class="glyphicon glyphicon-remove"
															*ngIf="myForm.controls.dependenton.controls.length > 1"
															(click)="removeSection_depententon(ix)"></span>

													</div>
												</div>
											</div>
											<div class="row">
												<div class="form-group col-md-12">
													<a class="btn btn-primary add-button pull-right"
														(click)='AddDependentOn("");'><i title="Add Dependent On"
															class="glyphicon glyphicon-plus"></i></a>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label>Relaxation On:</label>
										<select required name='relaxFields' id="relaxFields"
											formControlName="relaxFields">
											<option value=''>--Select--</option>
											<option *ngFor="let inputVal of inputFiledSel" value="{{inputVal.keyVal}}">
												{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
										</select>
										<!--div class="alert alert-danger" *ngIf="relaxFieldsM.errors?.required && ageform.submitted">Relaxation On is required.</div-->
									</div>
									<div class="form-group">
										<label>DOB Validation For:</label>
										<select required name='dobVal' id="dobVal" formControlName="dobVal">
											<option value=''>--Select--</option>
											<option *ngFor="let inputVal of inputFiledSel"
												value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
												{{inputVal.DisplayVal}} -
												{{inputVal.keyVal}}</option>
										</select>
										<!--div class="alert alert-danger" *ngIf="relaxFieldsM.errors?.required && ageform.submitted">Relaxation On is required.</div-->
									</div>
									<div class="form-group">
										<label>Age Display On:</label>
										<select required name='ageVal' id="ageVal" formControlName="ageVal">
											<option value=''>--Select--</option>
											<option *ngFor="let inputVal of inputFiledSel"
												value="{{inputVal.pageCompVal+'-'+inputVal.keyVal}}">
												{{inputVal.DisplayVal}} -
												{{inputVal.keyVal}}</option>
										</select>
										<!--div class="alert alert-danger" *ngIf="relaxFieldsM.errors?.required && ageform.submitted">Relaxation On is required.</div-->
									</div>

								</div>
							</div>
							<div class="">
								<div class="form-group">
									<h1 class="rule-main-head">Age Relaxation</h1>
									
									<div class="">
										<h2 class="rule-sub-head" style="margin-bottom: 0;">
											Age Config
										</h2>
										

										<form [formGroup]="myFormAge" novalidate (ngSubmit)="onSubmitAge(model._id)" style="position: relative">

											<div class="col-md-12" formArrayName="age">
												<div *ngFor="let language of myFormAge['controls']['age']['controls']; let ix=index"
													class="row age-config-row">
													<div formGroupName="{{ix}}" class="age">
														<div class="form-group col-md-2">
															<label class="" for="appStartDate">As on
																Date</label>
															<ngx-datepicker class="" name="ageAsonDate"
																[options]="options" formControlName="ageAsonDate"
																required>
															</ngx-datepicker>
														</div>
														<div class="form-group col-md-2">
															<label class="" for="appStartDate">Min
																Date</label>
															<ngx-datepicker class="" name="ageMinDate"
																[options]="options" formControlName="ageMinDate"
																required>
															</ngx-datepicker>
														</div>
														<div class="form-group col-md-2">
															<label class="" for="appStartDate">Max
																Date</label>
															<ngx-datepicker class="" name="ageMaxDate"
																[options]="options" formControlName="ageMaxDate"
																required>
															</ngx-datepicker>
														</div>

														<div class="col-md-6">
														<div class="form-group col-md-4">
															<label class="" for="appStartDate">Min Age</label>
															<input type="text" required class="form-control"
																id="ageMin" placeholder="Enter Minimum Age"
																name="ageMin" formControlName="ageMin">
														</div>
														<div class="form-group col-md-4">
															<label class="" for="appStartDate">Max Age</label>
															<input type="text" required class="form-control"
																id="ageMax" placeholder="Enter Maximum Age"
																name="ageMax" formControlName="ageMax">
														</div>
														<div class="form-group col-md-4">
															<label class="" for="appStartDate">Relaxation
																Limit</label>
															<input type="text" required class="form-control"
																id="ageRel" placeholder="Enter Age Relaxation"
																name="ageRel" formControlName="ageRel">
														</div>
														</div>
														<div class="form-group age-confic-action-icon">
															
															<i style="font-size: 14px;" class="fa d-inline fa-lg fa-eye view-icon"  title="Add Relaxation"
																(mouseenter)="jsonpreviewView(ruleData.rulesJsonLogic,'show')"></i>
															<span title="Remove Age Config" class="glyphicon glyphicon-trash del"
																*ngIf="myFormAge.controls.age.controls.length > 1"
																(click)="removeSectionAge(ix)"></span>

														</div>
													</div>




												</div>
											</div>
											<div class="row" formArrayName="age">
												
												<div class="form-group age-confic-add-btn">
													<button title="Add Age Config" type="button" class="btn add-button btn-sm"
														(click)="generateAge('')">
														<span class="glyphicon glyphicon-plus"></span>
													</button>
												</div>
												<div class="col-md-12">
												<button type="submit" class="btn btn-primary pull-right mt-4">Submit</button>
											</div>
											</div>
										</form>
									</div>

									<h2 class="rule-sub-head">
										Age Relaxation
									</h2>
									<div class="py-1 relaxation-box" *ngFor="let ageRel of ageRelaxationList;let i=index;">
										
										<div class="row">
											<div class="col-md-12 dependent-select" *ngFor="let dependentfieldlength of dependentkeys; let iz=index;">
												<select *ngIf="(ageDep.value == 'Y')?true:false" required
													name='ageDependentFields{{i}}{{iz}}' id="ageDependentFields"
													formControlName="ageDependentFields{{i}}{{iz}}">
													<option value=''>--Select--</option>
													<option *ngFor="let inputVal of finaldata[dependentfieldlength]"
														value="{{inputVal.value}}">{{inputVal.name}}
													</option>
												</select>
											</div>
											<div class="col-md-12">
												<div class="row">
												<div class="col-md-2">
													<label class="" for="appStartDate">As on Date</label>
											<input type="text" title="As on Date"
												value="{{ageRel.ageAsonDate.substring(0, 10)| date: 'dd/MM/yyyy'}}" disabled>

											</div>
											<div class="col-md-2">
												<label class="" for="appStartDate">Minimum Date</label>
											<input type="text" title="Minimum Date"
												value="{{ageRel.ageMinDate.substring(0, 10)| date: 'dd/MM/yyyy'}}" disabled>
												</div>
											<div class="col-md-2">
												<label class="" for="appStartDate">Maximum Date</label>
											<input type="text" title="Maximum Date"
												value="{{ageRel.ageMaxDate.substring(0, 10)| date: 'dd/MM/yyyy'}}" disabled>
											</div>
											<div class="col-md-2">
												<label class="" for="appStartDate">Minimum Age</label>
											<input type="text" title="Minimum Age" value="{{ageRel.ageMin}}" disabled>
										</div>
										<div class="col-md-2">
											<label class="" for="appStartDate">Maximum Age</label>
											<input type="text" title="Maximum Age" value="{{ageRel.ageMax}}" disabled>
										</div>
										<div class="col-md-2">
											<label class="" for="appStartDate">Relaxation Limit</label>
											<input type="text" title="Relaxation Limit" value="{{ageRel.ageRel}}"
												disabled>
												</div>
											</div>
												</div>
										</div>
										<div *ngIf="(relaxFields.value!='' && relaxationlistcount[i] > 0)?true:false"
											class="" formArrayName="rel{{i+1}}">
											<span class="btn add-button pull-right"
											(click)='showRelaxation(i,relaxationlistcount[i],relaxFields.value);'><i
												title="Add Relaxation" class="glyphicon glyphicon-plus"></i></span>
											<div *ngFor="let language of relaxFieldCount[i+1]; let iy=index"
												class="col-md-12 lable-height">
												<div formGroupName="{{iy}}" class="rel{{i+1}}">
													<div class="row" *ngIf="language=='value'">
														<div class="form-group col-md-2">
															<label class=""
																for="appStartDate">Relaxation</label>
															<select class="form-control" required
																name='relaxFormField' id="relaxFormField_{{iy}}"
																formControlName="relaxFormField">
																<option value=''>--Select--</option>
																<option *ngFor="let inputVal of inputFiledSel"
																	value="{{inputVal.keyVal}}">{{inputVal.DisplayVal}}
																	-
																	{{inputVal.keyVal}}</option>
															</select>

															<select class="form-control" required
																name='relaxFormField_sec' id="relaxFormField_sec_{{iy}}"
																formControlName="relaxFormField_sec"
																(change)="getSecondaryOpt(i+1,iy)">
																<option value=''>--Select--</option>
																<option
																	*ngFor="let inputVal of inputFiledSel  | searchfilter: [{'typeVal' : 'select'},{'typeVal' : 'radio'},{'typeVal' : 'selectboxes'}]"
																	value="{{inputVal.keyVal}}">{{inputVal.DisplayVal}}
																	-
																	{{inputVal.keyVal}}</option>
															</select>

															<select
																*ngIf="(getParentfieldVal(i+1,iy) && RelaxFieldThird[i+1][iy].length>0)?true:false"
																class="form-control" required
																name='relaxFormField_third'
																id="relaxFormField_third_{{iy}}"
																formControlName="relaxFormField_third">
																<option value=''>--Select--</option>
																<option
																	*ngFor="let inputVal of RelaxFieldThird[i+1][iy]"
																	value="{{inputVal.value}}">{{inputVal.name}}
																</option>
															</select>
														</div>
														<div class="form-group col-md-2">
															<label class="">Add Service <span>(Non Mandatory)</span></label>
															<select class="form-control col-md-12" required
																name='relaxFormFieldAvail'
																id="relaxFormFieldAvail_{{iy}}"
																formControlName="relaxFormFieldAvail">
																<!-- <select   class="form-control col-md-12" required name='relaxFormFieldAvail' id="relaxFormFieldAvail_{{iy}}"  formControlName="relaxFormFieldAvail" (change)="getSecondaryOpt(i+1,iy,'Avail')">  -->
																<option value=''>--Select--</option>
																<option
																	*ngFor="let inputVal of inputFiledSel | searchfilter: [{'typeVal' : 'textfield'},{'typeVal':'number'}]"
																	value="{{inputVal.keyVal}}">{{inputVal.DisplayVal}}
																	-
																	{{inputVal.keyVal}}</option>
															</select>

															<input
																*ngIf="(getParentfieldVal(i+1,iy,'Avail'))?true:false"
																type="text" required class="form-control col-md-12"
																id="relaxFormFieldAvail_sec_{{iy}}"
																placeholder="Serviceman Relax Limits"
																name="relaxFormFieldAvail_sec"
																formControlName="relaxFormFieldAvail_sec">
														</div>
														<div class="form-group col-md-2">
															<label class="">Additional Condition</label>
															<select class="form-control col-md-12" required
																name='genderFormField_first'
																id="genderFormField_first_{{iy}}"
																formControlName="genderFormField_first"
																(change)="getSecondaryOptGender(i+1,iy)">
																<option value=''>--Select--</option>
																<option
																	*ngFor="let inputVal of inputFiledSel  | searchfilter: [{'typeVal' : 'select'},{'typeVal' : 'radio'},{'typeVal' : 'selectboxes'}]"
																	value="{{inputVal.keyVal}}">{{inputVal.DisplayVal}}
																	-
																	{{inputVal.keyVal}}</option>
															</select>
															<select
																*ngIf="(getParentfieldVal(i+1,iy,'Gender') && GenderFieldSecond[i+1][iy].length>0)?true:false"
																class="form-control col-md-12" required
																name='genderFormField_sec'
																id="genderFormField_sec_{{iy}}"
																formControlName="genderFormField_sec">
																<option value=''>--Select--</option>
																<option
																	*ngFor="let inputVal of GenderFieldSecond[i+1][iy]"
																	value="{{inputVal.value}}">
																	{{inputVal.name}}</option>
															</select>
														</div>
														<div class="col-md-6">
														<div class="form-group col-md-2"
															*ngFor="let value of relaxFieldVal">
															<label class=""
																for="appStartDate">{{value}}</label>
															<input type="text" required class="form-control col-md-12"
																id="{{value}}" placeholder="{{value}} Relaxation"
																name="{{value}}" formControlName="{{value}}">
														</div>
													</div>
														<!--div class="form-group col-md-2">
											  <label class=" col-md-12" for="appStartDate">ST</label>
											  <input type="text" required class="form-control col-md-12" id="ST" placeholder="ST Relaxation" name="ST" formControlName="ST" >
										  </div>
										  <div class="form-group col-md-2">
											  <label class=" col-md-12" for="appStartDate">OBC</label>
											  <input type="text" required class="form-control col-md-12" id="OBC" placeholder="OBC Relaxation" name="OBC" formControlName="OBC" >
										  </div>
										  <div class="form-group col-md-2">
											  <label class=" col-md-12" for="appStartDate">Gen</label>
											  <input type="text" required class="form-control col-md-12" id="Gen" placeholder="Gen Relaxation" name="Gen" formControlName="Gen" >
										  </div-->
														<!--button class="btn btn-primary pull-right" (click)='showRelaxation(i,iy,relaxFields.value);'><i title="Add Relaxation" class="glyphicon glyphicon-plus"></i></button-->
														<div class="age-confic-action-icon">
														<span title="Remove Relaxation"
															class="glyphicon glyphicon-trash del pull-right"
															*ngIf="relaxationlistcount[i] > 1"
															(click)="removeSection(i,relaxationlistcount[i],iy)"></span>
														</div>
													</div>
												</div>
											</div>
										</div>
										
									</div>
								</div>
								<div class="row">
									<button type="submit" class="btn btn-primary ">Submit</button>
									<!-- <button *ngIf="(deletebtn)" type="button" class="btn btn-danger " (click)="deleteAgeRelax()">Delete Age</button> -->
								</div>
							</div>


						</form>
					</div>
				</div>
			</div>
		</div>

		<div class="col-md-12">
			<div class="rule-box" *ngIf='showDependent' id="dependentContainer">
				<div class="">
					
					<div class="dependent-sub-menu">
						<a class="btn" (click)='showUpload();'>Dependent Field Data</a>
					
						<a class="btn" (click)='showMapping();'>
							Map
							Fields</a>
				
						<a class="btn" (click)='showVacancyMapping();'>
							Vacancy Maping</a>
					</div>
				</div>

				<div class="col-md-12" *ngIf='showUploadSec' id="dependentContainer_sub1">
					<div class="row">
						<form class="" (ngSubmit)="dependentData(dependentDataform)" #dependentDataform="ngForm"
							enctype="multipart/form-data" novalidate>
							<div class="form-group">
								<label>Dependent Field:</label>
								<select required name='depField' id="depField" [(ngModel)]="depmodel.depField">
									<option value=''>--Select--</option>
									<option *ngFor="let inputVal of inputFiledSel" value="{{inputVal.keyVal}}">
										{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
								</select>
								<!--div class="alert alert-danger" *ngIf="formFieldsM.errors?.required && ageform.submitted">Dependent On is required.</div-->
							</div>
							<div class="form-group">
								<label class="" for="depData">Upload CSV</label>
								<input class="input-upload" type="file" id="depData" name="depData" (change)="uploadData($event)"
									[(ngModel)]="depmodel.depData" />
								<!-- <div *ngIf="rtnData && rtnData.message.doccategory" class="alert alert-danger">
						{{rtnData.message.doccategory}}
					  </div> -->
							</div>

							<div class="row">
								<button type="submit" class="btn btn-primary ">Submit</button>
							</div>
						</form>
					</div>
					<div class="row" *ngIf="(masterData.length > 0)?true:false">
						<div class="col-md-8"></div>
						<div class="col-md-4 mb-2 mt-4">
						<select required name='masterDocument' id="masterDocument" [(ngModel)]="masterDocument"
							(change)="getDocumentData(masterDocument)">
							<option value=''>--Select--</option>
							<option *ngFor="let document of masterData" value="{{document.documentName}}">
								{{document.documentName}}</option>
						</select>
					</div>
					<div class="table-responsive">
						<table class="table table-fixed table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th class="col-md-2 col-sm-2 col-xs-2">Key</th>
									<th class="col-md-8 col-sm-8 col-xs-8">Value</th>
									<th class="col-md-2 col-sm-2 col-xs-2">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let data of tableData; let i = index">
									<!-- <td colspan="3"><table class="table">
						  <tr> -->
									<td class="col-md-2 col-sm-2 col-xs-2">{{data.Key}}</td>
									<td class="col-md-8 col-sm-8 col-xs-8">{{data.Value}}</td>
									<td class="col-md-2 col-sm-2 col-xs-2">
										<!--i class="fa d-inline fa-lg fa-edit " (click)="editData(data)" ></i-->
										<i class="fa d-inline del fa-lg fa-trash-o" title="Remove"
											(click)="updateMasterData(data,masterDocument)"></i>
									</td>
								</tr>

								<tr *ngIf="tableData.length == 0">
									<td class="col-md-12" colspan='3'>No data found.</td>
								</tr>
							</tbody>
						</table>
						</div>
					</div>
				</div>
				<div class="col-md-12" *ngIf='showMappingSec' id="dependentContainer_sub2">
					<div class="row">
						<form class="mappingFrm" (ngSubmit)="saveMappingData(mappingFrm,mappingModel.id)"
							#mappingFrm="ngForm" novalidate>
							<div class="form-group">
								<label>Parent Field:</label>
								<select required name='parentField' id="parentField"
									[(ngModel)]="mappingModel.parentField"
									(change)="getParentData(mappingModel.parentField)">
									<option value=''>--Select--</option>
									<option *ngFor="let inputVal of inputFiledSel" value="{{inputVal.keyVal}}">
										{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
								</select>
								<div class="alert alert-danger" *ngIf="formFieldsM && formFieldsM.message.parentField">
									Parent Field is required.</div>
							</div>
							<div class="form-group" *ngIf="(mappingModel.parentField != '')?true:false">
								<label>Parent Data:</label>
								<select required name='parentData' id="parentData"
									[(ngModel)]="mappingModel.parentData">
									<option value=''>--Select--</option>
									<option *ngFor="let options of parentData" value="{{options.Key}}">{{options.Value}}
									</option>
								</select>
								<div class="alert alert-danger" *ngIf="formFieldsM && formFieldsM.message.parentData">
									Parent
									Data is required.</div>
							</div>
							<div class="form-group">
								<label>Dependent Field:</label>
								<select required name='childField' id="childField" [(ngModel)]="mappingModel.childField"
									(change)="getListData(mappingModel.childField)">
									<option value=''>--Select--</option>
									<option *ngFor="let inputVal of inputFiledSel" value="{{inputVal.keyVal}}">
										{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
								</select>
								<div class="alert alert-danger" *ngIf="formFieldsM && formFieldsM.message.childField">
									Dependent Field is required.</div>
							</div>
							<div class="form-group" *ngIf="(mappingModel.childField != '')?true:false">
								<label>Dependent Data :</label>
								<select required name='childData' id="childData" [(ngModel)]="mappingModel.childData"
									multiple>
									<!--option value=''>--Select--</option-->
									<option *ngFor="let options of listData" value="{{options.Key}}">{{options.Value}}
									</option>
								</select>
								<div class="alert alert-danger" *ngIf="formFieldsM && formFieldsM.message.childData">
									Dependent Data is required.</div>
							</div>
							<div class="row">
								<div class="col-md-12 mb-4">
								<button type="button" style="margin: 0;" class="btn btn-secondary" name="cancel_btn" (click)="resetMappingForm()"
									value="Cancel">Cancel</button>
								<button type="submit" class="btn btn-primary">Submit</button>
							</div>
							</div>
						</form>
					</div>
					<div class="row">
						<div class="table-responsive">
							<table class="table table-fixed table-striped table-bordered table-hover">
								<thead>
							<tr>
								<th class="col-md-3 col-sm-3 col-xs-3">Parent Field</th>
								<th class="col-md-3 col-sm-3 col-xs-3">Dependent Field</th>
								<th class="col-md-2 col-sm-2 col-xs-2">parent Data</th>
								<th class="col-md-2 col-sm-2 col-xs-2">Dependent Data</th>
								<th class="col-md-2 col-sm-2 col-xs-2">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let mapData of fldMappingData; let i = index">
								<!-- <td colspan="3"><table class="table">
						  <tr> -->
								<td class="col-md-3 col-sm-3 col-xs-3">{{mapData.parentField}}</td>
								<td class="col-md-3 col-sm-3 col-xs-3">{{mapData.childField}}</td>
								<td class="col-md-2 col-sm-2 col-xs-2">{{mapData.mapping.parentData}}</td>
								<td class="col-md-2 col-sm-2 col-xs-2">{{mapData.mapping.childData}}</td>
								<td class="col-md-2 col-sm-2 col-xs-2"><i class="fa d-inline fa-lg fa-edit" title="Edit" (click)="editData(mapData)"></i>
									<i class="fa del d-inline fa-lg fa-trash-o" title="Remove"
										(click)="delData(mapData._id, mapData.mapping._mappingid)"></i>
								</td>
								<!-- <td (click)="toggleMapData()">{{isOpen ? 'open' : 'closed'}}</td> -->
								<!-- </tr> -->
								<!-- <app-mapping-data  [@openClose]="isOpen ? 'open' : 'closed'" [mappingData]="mapData"></app-mapping-data> -->
								<!-- </table></td> -->
								<!--td><span [ngClass]="ruleData.rule_status == 'Active' ? 'label label-success' : 'label label-warning'"> {{ruleData.rule_status}}</span></td-->
							</tr>

							<tr *ngIf="fldMappingData.length == 0">
								<td class="col-md-12">No Mapping data found.</td>
							</tr>
						</tbody>
					</table>
					</div>
				</div>
				</div>
				<div class="" *ngIf='showVacancySec' id="dependentContainer_sub3">
					<form class="" (ngSubmit)="onvacancyFormSubmit()" [formGroup]="vacancyForm" novalidate>
						<div class="form-group">
							<label>Parent Field:</label>
							<select required formControlName="depFieldVacancy" (change)="onFldChange()">
								<option value=''>--Select--</option>
								<option *ngFor="let inputVal of inputFiledSel" value="{{inputVal.keyVal}}">
									{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
							</select>
							<div class="alert alert-danger" *ngIf="formFieldsM && formFieldsM.message.depFieldVacancy">
								Parent Field is required.</div>
						</div>
						<div class="form-group">
							<label>Vacancy Field:</label>
							<select required formControlName="vacancyField" (change)="onFldChange()">
								<option value=''>--Select--</option>
								<option *ngFor="let inputVal of inputFiledSel" value="{{inputVal.keyVal}}">
									{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
							</select>
							<div class="alert alert-danger" *ngIf="formFieldsM && formFieldsM.message.vacancyField">
								Vacancy
								Field is required.</div>
						</div>
						<div *ngIf="(vacancyField.value!='' && depFieldVacancy.value != '')?true:false">
							<div class="row">
								
							<div  class="col-md-4 mb-5" *ngFor="let option of vacancyParent">
								<div class="" formGroupName="{{option}}">
									<label>{{option}}</label>

									<div *ngFor="let option1 of vacancyChild" class="form-check"
										style="padding-right:20px;">
										<label class="form-check-label" style="width: 100%;">
											<input class="chk_txt web-kit" type="checkbox" formControlName="{{option1}}">
											<span >
												{{option1}}</span>
										</label>
									</div>
									
								
							</div>
						</div>
						</div>
						</div>
						<div class="row">
							<div class="col-md-12 mb-4">
							<button style="margin: 0;" type="button" class="btn btn-secondary" name="cancel_btn" (click)="resetVacancyForm()"
								value="Cancel">Cancel</button>
							<button type="submit" class="btn btn-primary ">Submit</button>
						</div>
						</div>
					</form>
					<div class="table-responsive">
						<table class="table table-fixed table-striped table-bordered table-hover">
							<thead>
							<tr>
								<th class="col-md-5 col-sm-5 col-xs-5">Parent Field</th>
								<th class="col-md-5 col-sm-5 col-xs-5">Vacancy Field</th>
								<th class="col-md-2 col-sm-2 col-xs-2">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let mapData of fldMappingData; let i = index">
								<td class="col-md-5 col-sm-5 col-xs-5">{{mapData.depFieldVacancy}}</td>
								<td class="col-md-5 col-sm-5 col-xs-5">{{mapData.vacancyField}}</td>
								<td class="col-md-2 col-sm-2 col-xs-2"><i class="fa d-inline fa-lg fa-edit " title="Edit" (click)="editMappingData(mapData)"></i>
									<i class="fa del d-inline fa-lg fa-trash-o" title="Remove"
										(click)="delMappingData(mapData._id, mapData.vacancyField)"></i>
								</td>
								<!--td><span [ngClass]="ruleData.rule_status == 'Active' ? 'label label-success' : 'label label-warning'"> {{ruleData.rule_status}}</span></td-->
							</tr>

							<tr *ngIf="fldMappingData.length == 0">
								<td class="col-md-12">No Mapping data found.</td>
							</tr>
						</tbody>
					</table>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12">
			<div class="rule-box" *ngIf='showPreference' id="dependentContainer">
				<div class="row">
					<div class="dependent-sub-menu">
						<a class="btn btn-primary " (click)='showPreferenceUpload();'>Preference Field Data</a>
					</div>
				</div>

				<div class="" *ngIf='showUploadSecPref' id="dependentContainer_sub1">
					<div class="">
						<form class="" (ngSubmit)="preferenceData(preferenceDataform)" #preferenceDataform="ngForm"
							enctype="multipart/form-data" novalidate>
							<div class="form-group">
								<label>Dependent Field:</label>
								<select required name='depField' id="depField" [(ngModel)]="depmodel.depField">
									<option value=''>--Select--</option>
									<option *ngFor="let inputVal of inputFiledSel" value="{{inputVal.keyVal}}">
										{{inputVal.DisplayVal}} - {{inputVal.keyVal}}</option>
								</select>
								<!--div class="alert alert-danger" *ngIf="formFieldsM.errors?.required && ageform.submitted">Dependent On is required.</div-->
							</div>
							<div class="form-group">
								<label for="depData">Upload CSV</label>
								<input class="input-upload" type="file" id="depData" name="depData" (change)="uploadData($event)"
									[(ngModel)]="depmodel.depData" />
								<!-- <div *ngIf="rtnData && rtnData.message.doccategory" class="alert alert-danger">
						{{rtnData.message.doccategory}}
					  </div> -->
							</div>

							<div class="row">
								<button type="submit" class="btn btn-primary ">Submit</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<div class="col-md-12">
			<div class="rule-box" *ngIf='showGridMandatorySec' id="gridMandatoryCheckContainer">
				<h1 class="rule-main-head">Grid Validations</h1>
				<form class="" (ngSubmit)="gridCheckSubmit()" [formGroup]="myFormGridCheck" novalidate>

					<!-- <div formArrayName="gridCheck"> -->
					<div class="form-group">
						<div>
							<label>Choose Your Grid</label>
							<select class="form-control col-md-12" required name='gridcomp' id="gridcomp"
								(change)="getGridValues($event)" formControlName="gridcomp">
								<option value=''>--Select--</option>
								<option *ngFor="let inputVal of dataGridName" value="{{inputVal}}">{{inputVal}}</option>
							</select>

						</div>&nbsp;
						<div>
							<div>
								<label>
									Choose One
								</label>
							</div>
							<input type="radio" id="chooseone" formControlName="chooseone" value="mandatory" />Make all
							fields
							Mandatory in a row &nbsp;
							<input type="radio" id="chooseone" formControlName="chooseone" value="nullcheck" /> Check
							null
							values
							and
							validate
						</div>&nbsp;

						<div *ngIf="getGridDataFlag;else gridDataFlag ">
							<label>Choose the fields to validate</label>

							<div *ngFor="let gridval of fetchedGridValues">
								<input type="checkbox" (change)="onSelectValues(gridval, $event.target.checked)"
									value="{{gridval}}" name="{{gridval}}" id="{{gridval}}" />{{gridval}}
							</div>&nbsp;
							<div class="row">
								<button type="submit" class="btn btn-primary ">Submit</button>
							</div>
						</div>
						<ng-template #gridDataFlag>
							<label>Choose the fields to validate</label>

							<div *ngFor="let gridval of gridValuesArr">
								<input type="checkbox" (change)="onSelectValues(gridval, $event.target.checked)"
									value="{{gridval}}" name="{{gridval}}" id="{{gridval}}" checked />{{gridval}}
							</div>&nbsp;
							<div class="row">
								<button type="submit" class="btn btn-primary ">Submit</button>
							</div>
						</ng-template>

					</div>



				</form>
			</div>
		</div>
	</div>
	<ngx-loading [show]="loading"></ngx-loading>
</div>
